import { SelectItem } from "primeng/api";

import { environment } from "../../environments/environment";
import { opt } from "../i18n/i18n";
export const APP_API = "api/v1/";

export const CLIENTS_API = environment.baseUrl + APP_API + "locations";
export const BOOKINGS_API = environment.baseUrl + APP_API + "bookings";
export const LOCATIONS_API = environment.baseUrl + APP_API + "locations";
export const PARAM_PAGES_PATH = "/admin/pages/";

export const PARAM_WORKS_PATH = "/admin/settings/works/";
export const PARAM_CATEGORIES_PATH = "/admin/settings/categories/";
export const PARAM_LOCATIONS_TYPE_PATH = "/admin/settings/locations/";
export const PARAM_COMUNI_PATH = "/admin/settings/comuni/";

export const PARAM_TAGS_PATH = "/admin/settings/tags/";
export const PARAM_PERSONAL_DATA_PATH = "/admin/settings/personal-data/";
export const PARAM_TYPE_PATH = "/admin/settings/type/";

export const PARAM_BRANDS_PATH = "/admin/settings/brands/";
export const PARAM_COMPANY_PATH = "/admin/settings/company/";

export const PARAM_TECHNICAL_DATA_PATH = "/admin/settings/technical-data/";
export const PARAM_WAREHOUSES_PATH = "/admin/settings/warehouses/";
export const PARAM_CHECKINS_PATH = "/admin/checkins/";

export const PARAM_WAREHOUSE_MOVEMENTS_PATH = "/admin/warehouse-movements/";

export const PARAM_CHECKOUTS_PATH = "/admin/checkouts/";
export const PARAM_TIMESHEETS_PATH = "/admin/timesheets/";
export const PARAM_BILLINGS_PATH = "/admin/billings/";
export const PARAM_PURCHASE_ORDERS_PATH = "/admin/purchase-orders/";

export const PARAM_TRANSPORT_DOCUMENTS_PATH = "/admin/transport-documents/";
export const PARAM_QUOTES_PATH = "/admin/quotes/";
export const PARAM_ORDERS_PATH = "/admin/orders/";
export const PARAM_DOCUMENTS_PATH = "/admin/documents/";

export const PARAM_EMPLOYEE_TIMESHEETS_PATH = "/employee/timesheets/";
export const PARAM_ROOMS_PATH = "/admin/rooms/";
export const PARAM_DASHBOARD_PATH = "/admin/dashboard/";
export const PARAM_EMPLOYEES_PATH = "/admin/employees/";
export const PARAM_CLIENTS_PATH = "/admin/clients/";
export const PARAM_REQUESTS_PATH = "/admin/requests/";
export const PARAM_SUPPLIERS_PATH = "/admin/suppliers/";
export const PARAM_SUPPORTS_PATH = "/admin/support/";
export const PARAM_PROJECTS_PATH = "/admin/projects/";
export const PARAM_PROJECTS_TIMESHEET_PATH = "/admin/projects/timesheet/";

export const PARAM_BOOKINGS_PATH = "/admin/bookings/";
export const PARAM_BOOKINGS_TYPE_PATH = "/admin/settings/booking-type/";
export const PARAM_CALENDAR_PATH = "/admin/calendar/";

export const LEVEL_PUBLISHED = [
  opt("Nessun valore", ""),

  opt("low", "0"),
  opt("middle", "1"),
  opt("high", "2"),
];

export const STATE_PAGES_PUBLISHED = [
  opt("Nessun valore", ""),
  opt("published", "published"),
  opt("unpublished", "unpublished"),
];

export const NUMBER_LIST: SelectItem[] = [
  opt("scegli", null),
  { label: "1", value: "1" },
  { label: "2", value: "2" },
  { label: "3", value: "3" },
  { label: "4", value: "4" },
  { label: "5", value: "5" },
  { label: "6", value: "6" },
  { label: "7", value: "7" },
  { label: "8", value: "8" },
  { label: "9", value: "9" },
];

export const NUMBER_LIST_CHILDREN: SelectItem[] = [
  opt("scegli", null),
  { label: "0", value: "0" },
  { label: "1", value: "1" },
  { label: "2", value: "2" },
  { label: "3", value: "3" },
  { label: "4", value: "4" },
  { label: "5", value: "5" },
  { label: "6", value: "6" },
  { label: "7", value: "7" },
  { label: "8", value: "8" },
  { label: "9", value: "9" },
];

export const LOCATIONS_LIST: SelectItem[] = [
  opt("Pagamento in struttura", "1"),
  opt("Pagamento online", "2"),
];

export const WORKS_LIST: SelectItem[] = [
  opt("Gatto", "1"),
  opt("Cane", "2"),
];

export const BOOKINGS_TYPE: SelectItem[] = [
  opt("Svago", "1"),
  opt("Business", "2"),
];

export const COUNTRY_LIST: SelectItem[] = [
  { label: "Select Country", value: null },
  { label: "Afghanistan", value: "AF" },
  { label: "Albania", value: "AL" },
  { label: "Algeria", value: "DZ" },
  { label: "Andorra", value: "AD" },
  { label: "Angola", value: "AO" },
  { label: "Antigua and Barbuda", value: "AG" },
  { label: "Argentina", value: "AR" },
  { label: "Armenia", value: "AM" },
  { label: "Australia", value: "AU" },
  { label: "Austria", value: "AT" },
  { label: "Azerbaijan", value: "AZ" },
  { label: "Bahamas", value: "BS" },
  { label: "Bahrain", value: "BH" },
  { label: "Bangladesh", value: "BD" },
  { label: "Barbados", value: "BB" },
  { label: "Belarus", value: "BY" },
  { label: "Belgium", value: "BE" },
  { label: "Belize", value: "BZ" },
  { label: "Benin", value: "BJ" },
  { label: "Bhutan", value: "BT" },
  { label: "Bolivia", value: "BO" },
  { label: "Bosnia and Herzegovina", value: "BA" },
  { label: "Botswana", value: "BW" },
  { label: "Brazil", value: "BR" },
  { label: "Brunei Darussalam", value: "BN" },
  { label: "Bulgaria", value: "BG" },
  { label: "Burkina Faso", value: "BF" },
  { label: "Burundi", value: "BI" },
  { label: "Cabo Verde", value: "CV" },
  { label: "Cambodia", value: "KH" },
  { label: "Cameroon", value: "CM" },
  { label: "Canada", value: "CA" },
  { label: "Central African Republic", value: "CF" },
  { label: "Chad", value: "TD" },
  { label: "Chile", value: "CL" },
  { label: "China", value: "CN" },
  { label: "Colombia", value: "CO" },
  { label: "Comoros", value: "KM" },
  { label: "Congo", value: "CG" },
  { label: "Costa Rica", value: "CR" },
  { label: "Croatia", value: "HR" },
  { label: "Cuba", value: "CU" },
  { label: "Cyprus", value: "CY" },
  { label: "Czech Republic", value: "CZ" },
  { label: "Democratic Republic of the Congo", value: "CD" },
  { label: "Denmark", value: "DK" },
  { label: "Djibouti", value: "DJ" },
  { label: "Dominica", value: "DM" },
  { label: "Dominican Republic", value: "DO" },
  { label: "Ecuador", value: "EC" },
  { label: "Egypt", value: "EG" },
  { label: "El Salvador", value: "SV" },
  { label: "Equatorial Guinea", value: "GQ" },
  { label: "Eritrea", value: "ER" },
  { label: "Estonia", value: "EE" },
  { label: "Eswatini", value: "SZ" },
  { label: "Ethiopia", value: "ET" },
  { label: "Fiji", value: "FJ" },
  { label: "Finland", value: "FI" },
  { label: "France", value: "FR" },
  { label: "Gabon", value: "GA" },
  { label: "Gambia", value: "GM" },
  { label: "Georgia", value: "GE" },
  { label: "Germany", value: "DE" },
  { label: "Ghana", value: "GH" },
  { label: "Greece", value: "GR" },
  { label: "Grenada", value: "GD" },
  { label: "Guatemala", value: "GT" },
  { label: "Guinea", value: "GN" },
  { label: "Guinea-Bissau", value: "GW" },
  { label: "Guyana", value: "GY" },
  { label: "Haiti", value: "HT" },
  { label: "Honduras", value: "HN" },
  { label: "Hungary", value: "HU" },
  { label: "Iceland", value: "IS" },
  { label: "India", value: "IN" },
  { label: "Indonesia", value: "ID" },
  { label: "Iran", value: "IR" },
  { label: "Iraq", value: "IQ" },
  { label: "Ireland", value: "IE" },
  { label: "Israel", value: "IL" },
  { label: "Italy", value: "IT" },
  { label: "Jamaica", value: "JM" },
  { label: "Japan", value: "JP" },
  { label: "Jordan", value: "JO" },
  { label: "Kazakhstan", value: "KZ" },
  { label: "Kenya", value: "KE" },
  { label: "Kiribati", value: "KI" },
  { label: "Korea, North", value: "KP" },
  { label: "Korea, South", value: "KR" },
  { label: "Kuwait", value: "KW" },
  { label: "Kyrgyzstan", value: "KG" },
  { label: "Laos", value: "LA" },
  { label: "Latvia", value: "LV" },
  { label: "Lebanon", value: "LB" },
  { label: "Lesotho", value: "LS" },
  { label: "Liberia", value: "LR" },
  { label: "Libya", value: "LY" },
  { label: "Liechtenstein", value: "LI" },
  { label: "Lithuania", value: "LT" },
  { label: "Luxembourg", value: "LU" },
  { label: "Madagascar", value: "MG" },
  { label: "Malawi", value: "MW" },
  { label: "Malaysia", value: "MY" },
  { label: "Maldives", value: "MV" },
  { label: "Mali", value: "ML" },
  { label: "Malta", value: "MT" },
  { label: "Marshall Islands", value: "MH" },
  { label: "Mauritania", value: "MR" },
  { label: "Mauritius", value: "MU" },
  { label: "Mexico", value: "MX" },
  { label: "Micronesia", value: "FM" },
  { label: "Moldova", value: "MD" },
  { label: "Monaco", value: "MC" },
  { label: "Mongolia", value: "MN" },
  { label: "Montenegro", value: "ME" },
  { label: "Morocco", value: "MA" },
  { label: "Mozambique", value: "MZ" },
  { label: "Myanmar", value: "MM" },
  { label: "Namibia", value: "NA" },
  { label: "Nauru", value: "NR" },
  { label: "Nepal", value: "NP" },
  { label: "Netherlands", value: "NL" },
  { label: "New Zealand", value: "NZ" },
  { label: "Nicaragua", value: "NI" },
  { label: "Niger", value: "NE" },
  { label: "Nigeria", value: "NG" },
  { label: "North Macedonia", value: "MK" },
  { label: "Norway", value: "NO" },
  { label: "Oman", value: "OM" },
  { label: "Pakistan", value: "PK" },
  { label: "Palau", value: "PW" },
  { label: "Palestine", value: "PS" },
  { label: "Panama", value: "PA" },
  { label: "Papua New Guinea", value: "PG" },
  { label: "Paraguay", value: "PY" },
  { label: "Peru", value: "PE" },
  { label: "Philippines", value: "PH" },
  { label: "Poland", value: "PL" },
  { label: "Portugal", value: "PT" },
  { label: "Qatar", value: "QA" },
  { label: "Romania", value: "RO" },
  { label: "Russia", value: "RU" },
  { label: "Rwanda", value: "RW" },
  { label: "Saint Kitts and Nevis", value: "KN" },
  { label: "Saint Lucia", value: "LC" },
  { label: "Saint Vincent and the Grenadines", value: "VC" },
  { label: "Samoa", value: "WS" },
  { label: "San Marino", value: "SM" },
  { label: "Sao Tome and Principe", value: "ST" },
  { label: "Saudi Arabia", value: "SA" },
  { label: "Senegal", value: "SN" },
  { label: "Serbia", value: "RS" },
  { label: "Seychelles", value: "SC" },
  { label: "Sierra Leone", value: "SL" },
  { label: "Singapore", value: "SG" },
  { label: "Slovakia", value: "SK" },
  { label: "Slovenia", value: "SI" },
  { label: "Solomon Islands", value: "SB" },
  { label: "Somalia", value: "SO" },
  { label: "South Africa", value: "ZA" },
  { label: "South Sudan", value: "SS" },
  { label: "Spain", value: "ES" },
  { label: "Sri Lanka", value: "LK" },
  { label: "Sudan", value: "SD" },
  { label: "Suriname", value: "SR" },
  { label: "Sweden", value: "SE" },
  { label: "Switzerland", value: "CH" },
  { label: "Syria", value: "SY" },
  { label: "Taiwan", value: "TW" },
  { label: "Tajikistan", value: "TJ" },
  { label: "Tanzania", value: "TZ" },
  { label: "Thailand", value: "TH" },
  { label: "Togo", value: "TG" },
  { label: "Tonga", value: "TO" },
  { label: "Trinidad and Tobago", value: "TT" },
  { label: "Tunisia", value: "TN" },
  { label: "Turkey", value: "TR" },
  { label: "Turkmenistan", value: "TM" },
  { label: "Tuvalu", value: "TV" },
  { label: "Uganda", value: "UG" },
  { label: "Ukraine", value: "UA" },
  { label: "United Arab Emirates", value: "AE" },
  { label: "United Kingdom", value: "GB" },
  { label: "United States", value: "US" },
  { label: "Uruguay", value: "UY" },
  { label: "Uzbekistan", value: "UZ" },
  { label: "Vanuatu", value: "VU" },
  { label: "Vatican City", value: "VA" },
  { label: "Venezuela", value: "VE" },
  { label: "Vietnam", value: "VN" },
  { label: "Yemen", value: "YE" },
  { label: "Zambia", value: "ZM" },
  { label: "Zimbabwe", value: "ZW" },
];

export const TEMPLATE_PUBLISHED = [
  opt("Nessun valore", ""),

  opt("news", "news.php"),
  opt("events", "events.php"),
];

export const STATE_PUBLISHED = [
  opt("Nessun valore", ""),

  opt("published", "published"),
  opt("draft", "draft"),
  opt("not published", "not-published"),
];

export const FISCAL_CODE_VALIDATOR_REGEX =
  /^([A-Za-z]{6}[0-9lmnpqrstuvLMNPQRSTUV]{2}[abcdehlmprstABCDEHLMPRST]{1}[0-9lmnpqrstuvLMNPQRSTUV]{2}[A-Za-z]{1}[0-9lmnpqrstuvLMNPQRSTUV]{3}[A-Za-z]{1})$/g;

export const API_DATE_FORMAT = "yyyy-MM-DD[T]HH:mm:ss";
export const CHIPS_DATE_FORMAT = "DD/MM/yyyy HH:mm";

export interface SettingItem {
  label: string;
  value: string;
  icon: string;
  group: string;
  description: string;
}

export const SETTINGS: SettingItem[] = [
  {
    group: "Struttura",
    label: "Dati aziendali",
    value: "/admin/settings/company",
    icon: "pi pi-building",
    description: "Ragione sociale, partita IVA e dati per le fatture.",
  },
  {
    group: "Struttura",
    label: "Categorie Camere",
    value: "/admin/settings/categories",
    icon: "pi pi-tags",
    description: "Raggruppa le camere per tipologia.",
  },
  {
    group: "Struttura",
    label: "Dati aggiuntive Camere",
    value: "/admin/settings/technical-data",
    icon: "pi pi-sliders-h",
    description: "Servizi e caratteristiche delle camere.",
  },
  {
    group: "Struttura",
    label: "Tipo di Prenotazione",
    value: "/admin/settings/booking-type",
    icon: "pi pi-calendar-plus",
    description: "Tipi di vacanza selezionabili in una prenotazione.",
  },
  {
    group: "Ospiti",
    label: "Dati aggiuntive Clienti",
    value: "/admin/settings/personal-data",
    icon: "pi pi-id-card",
    description: "Campi extra nella scheda cliente.",
  },
  {
    group: "Ospiti",
    label: "Paesi",
    value: "/admin/settings/comuni",
    icon: "pi pi-globe",
    description: "Elenco dei paesi per gli indirizzi.",
  },
  {
    group: "Prenotazioni online",
    label: "Sito web e Widget",
    value: "/admin/settings/website",
    icon: "pi pi-desktop",
    description: "Installa il modulo di prenotazione e autorizza i siti.",
  },
  {
    group: "Prenotazioni online",
    label: "Pagamenti",
    value: "/admin/settings/payments",
    icon: "pi pi-credit-card",
    description: "Paga in hotel o con PayPal: cosa vede l'ospite.",
  },
];

export const PAGES: SelectItem[] = [
  {
    label: "Tipo di lavorazione",
    value: "/admin/settings/works",
    icon: "pi pi-list",
  },
  {
    label: "Tipo di Prenotazione",
    value: "/admin/settings/booking-type",
    icon: "pi pi-list",
  },
  {
    label: "Luogo di lavorazione",
    value: "/admin/settings/locations",
    icon: "pi pi-list",
  },
  {
    label: "Dati clienti aggiuntivi",
    value: "/admin/settings/personal-data",
    icon: "pi pi-list",
  },
];

export const ROOM_TYPE_LIST: SelectItem[] = [
  opt("Compra", "1"),
  opt("Affitto", "2"),
  opt("Aste", "3"),
  opt("Altro", "4"),
];

export const PAGES_ROOM: SelectItem[] = [
  { label: "Tags", value: "/admin/settings/tags", icon: "pi pi-list" },
  {
    label: "Marchi / Brands",
    value: "/admin/settings/brands",
    icon: "pi pi-list",
  },
  {
    label: "Categorie",
    value: "/admin/settings/categories",
    icon: "pi pi-list",
  },
  {
    label: "Dati technici",
    value: "/admin/settings/technical-data",
    icon: "pi pi-list",
  },
  {
    label: "Magazzino",
    value: "/admin/settings/warehouses",
    icon: "pi pi-list",
  },
];

export const PAGES_COMPANY: SelectItem[] = [
  {
    label: "Dati aziendali",
    value: "/admin/settings/company",
    icon: "pi pi-list",
  },
];

export const DASHBOARD: SelectItem[] = [
  { label: "Clienti", value: "./clients", icon: "" },
  opt("Prenotazioni", "./bookings"),
];

export const STATUS_PROJECTS: SelectItem[] = [
  opt("Tutte", null),
  opt("Fase di Esecuzione", "Esecuzione"),
  opt("Fase di Contrattazione", "Contrattazione"),
  opt("Fase di Elaborazione", "Elaborazione"),
  opt("Amministrazione", "Amministrazione"),
  opt("Altro", "Altro"),
];

export const PRIORITY_LIST: SelectItem[] = [
  opt("Da Fare", "1"),
  { label: "25 %", value: "2" },
  { label: "75 %", value: "3" },
  opt("Done", "4"),
];

export const STATUS_ROOMS: SelectItem[] = [
  opt("Disponibile", "1"),
  opt("Esaurito", "2"),
  opt("Esauriro temporaneamente", "3"),
  opt("In ordinazione", "4"),
  opt("Altro", "5"),
];

export const TIMESHEETS_TYPE: SelectItem[] = [
  opt("Lavoro", "1"),
  opt("Ferie", "2"),
  opt("Permesso", "3"),
  opt("Straordinari", "4"),
  opt("Altro", "5"),
];

export const LANG_IT = {
  closeText: "Chiudi",
  prevText: "&#x3C;Prec",
  nextText: "Succ&#x3E;",
  currentText: "Oggi",
  monthNames: [
    "Gennaio",
    "Febbraio",
    "Marzo",
    "Aprile",
    "Maggio",
    "Giugno",
    "Luglio",
    "Agosto",
    "Settembre",
    "Ottobre",
    "Novembre",
    "Dicembre",
  ],
  monthNamesShort: [
    "Gen",
    "Feb",
    "Mar",
    "Apr",
    "Mag",
    "Giu",
    "Lug",
    "Ago",
    "Set",
    "Ott",
    "Nov",
    "Dic",
  ],
  dayNames: [
    "Domenica",
    "Lunedì",
    "Martedì",
    "Mercoledì",
    "Giovedì",
    "Venerdì",
    "Sabato",
  ],
  dayNamesShort: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
  dayNamesMin: ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"],
  weekHeader: "Sm",
  dateFormat: "dd/mm/yy",
  firstDayOfWeek: 1,
  isRTL: false,
  showMonthAfterYear: false,
  yearSuffix: "",
};

export const STATE_LIST = [
  opt("Si", "1"),
  opt("No", "0"),
];

export const ACTIVE_STATE_LIST = [
  opt("Attivo", "1"),
  opt("Non attivo", "0"),
];

export const BILLING_LIST = [
  opt("Fattura", "Fattura"),
  opt("Ricevuta", "Ricevuta"),
];

export const CLIENT_TYPE_LIST = [
  opt("Privato", "1"),
  opt("Azienda", "0"),
];

export const BUSINESS_STATE_LIST = [
  opt("Hotel", "1"),
  opt("BnB", "0"),
];

export const EMPLOYEE_TYPE_LIST = [
  opt("Dipendente", "0"),
  opt("Socio", "1"),
];

export const STATUS_TYPE_LIST = [
  opt("pending", "0"),
  opt("confermata", "1"),
];

export const PAIED_TYPE_LIST = [
  opt("aperto", "0"),
  opt("pagato", "1"),
];

export const SEX_LIST: SelectItem[] = [
  opt("Tutte", null),
  opt("Uomo", "Uomo"),
  opt("Donna", "Donna"),
];

export const SIZE_LIST: SelectItem[] = [
  opt("20 mq", "20"),
  opt("40 mq", "40"),
  opt("60 mq", "60"),
  opt("80 mq", "80"),
  opt("100 mq", "100"),
  opt("120 mq", "120"),
  opt("140 mq", "140"),
  opt("160 mq", "160"),
  opt("180 mq", "180"),
  opt("200 mq", "200"),
  opt("250 mq", "250"),
  opt("300 mq", "300"),
  opt("350 mq", "350"),
  opt("400 mq", "400"),
  opt("450 mq", "450"),
  opt("500 mq", "500"),
];

export const ROOM_LIST: SelectItem[] = [
  { label: "1", value: "1" },
  { label: "2", value: "2" },
  { label: "3", value: "3" },
  { label: "4", value: "4" },
  { label: "5", value: "5" },
  { label: "6", value: "6" },
  { label: "7", value: "7" },
  { label: "8", value: "8" },
  { label: "9", value: "9" },
  { label: "10", value: "10" },
];

export const TYPE_LIST: SelectItem[] = [
  opt("Compra", "1"),
  opt("Affitto", "2"),
  opt("Aste", "3"),
  opt("Altro", "4"),
];

export const PRICE_LIST: SelectItem[] = [
  { label: "10.000", value: "10000" },
  { label: "20.000", value: "20000" },
  { label: "30.000", value: "30000" },
  { label: "40.000", value: "40000" },
  { label: "50.000", value: "50000" },
  { label: "60.000", value: "60000" },
  { label: "70.000", value: "70000" },
  { label: "80.000", value: "80000" },
  { label: "90.000", value: "90000" },
  { label: "100.000", value: "100000" },
  { label: "125.000", value: "125000" },
  { label: "150.000", value: "150000" },
  { label: "175.000", value: "175000" },
  { label: "200.000", value: "200000" },
  { label: "250.000", value: "250000" },
  { label: "300.000", value: "300000" },
  { label: "400.000", value: "400000" },
  { label: "500.000", value: "500000" },
  { label: "600.000", value: "600000" },
  { label: "700.000", value: "700000" },
  { label: "800.000", value: "800000" },
  { label: "900.000", value: "900000" },
  { label: "1.000.000", value: "1000000" },
];

export const ANNO_ITEMS: SelectItem[] = [
  opt("nessuno", ""),
  { label: "2021", value: "2021" },
  { label: "2020", value: "2020" },
  { label: "2019", value: "2019" },
  { label: "2018", value: "2018" },
  { label: "2017", value: "2017" },
  { label: "2016", value: "2016" },
  { label: "2015", value: "2015" },
  { label: "2014", value: "2014" },
  { label: "2013", value: "2013" },
  { label: "2012", value: "2012" },
  { label: "2011", value: "2011" },
  { label: "2010", value: "2010" },
  { label: "2009", value: "2009" },
];

export const TIPO_CONTENUTO_MILTILINGUA_ITEMS: SelectItem[] = [
  { label: "...", value: "..." },
  opt("Attività", "Attività"),
  opt("Contenuti Generici", "Contenuti Generici"),
  opt("Gallerie", "Gallerie"),
  opt("Servizi", "Servizi"),
  opt("Video", "Video"),
];

export const TIPO_CONTENUTO_ITEMS: SelectItem[] = [
  { label: "...", value: "..." },
  opt("Attività", "Attività"),
  opt("Contenuti Generici", "Contenuti Generici"),
  opt("Documenti", "Documenti"),
  opt("News", "News"),
  opt("Sedi", "Sedi"),
  opt("Servizi", "Servizi"),
  opt("Settori", "Settori"),
  opt("Sotto Attività", "Sotto Attività"),
  opt("Sotto Servizi", "Sotto Servizi"),
  opt("Storie", "Storie"),
];

export const MENU_ITEMS: any[] = [
  {
    link: "allegati",
    not: "",
    title: "Allegati",
    icon: "fa fa-paperclip",
    description: "Gestione dei Allegati",
  },
  {
    link: "attivita",
    not: "sotto",
    title: "Attività",
    icon: "fa fa-cogs",
    description: "Gestione delle Attività",
  },
  {
    link: "blog",
    not: "",
    title: "Blog",
    icon: "fa fa-book",
    description: "Blog",
  },
  {
    link: "contenuti-generici",
    not: "",
    title: "Contenuti Generici",
    icon: "fa fa-connectdevelop",
    description: "Gestione dei Contenuti Generici",
  },

  {
    link: "careers",
    not: "",
    title: "Careers",
    icon: "fa fa-file-o",
    description: "Offerte di lavoro",
  },
  {
    link: "formrequestcareer",
    not: "",
    title: " Curriculum",
    icon: "fa fa-envelope-o",
    description: "Curriculum",
  },

  {
    link: "documenti",
    not: "",
    title: "Documenti",
    icon: "fa fa-file-o",
    description: "Gestione dei Documenti",
  },
  {
    link: "multilingue",
    not: "",
    title: "Multilingue",
    icon: "fa fa-language",
    description: "Gestione delle Multilingue",
  },
  {
    link: "news",
    not: "",
    title: "News",
    icon: "fa fa-newspaper-o",
    description: "Gestione delle News",
  },
  {
    link: "sedi",
    not: "",
    title: "Sedi",
    icon: "fa fa-home",
    description: "Gestione delle Sedi",
  },
  {
    link: "servizi",
    not: "sotto",
    title: "Servizi",
    icon: "fa fa-server",
    description: "Gestione dei Servizi",
  },
  {
    link: "settori",
    not: "",
    title: "Settori",
    icon: "fa fa-wpforms",
    description: "Gestione dei Settori",
  },
  {
    link: "sottoattivita",
    not: "",
    title: "Sotto Attività",
    icon: "fa fa-cog",
    description: "Gestione delle Sotto Attività",
  },
  {
    link: "sottoservizi",
    not: "",
    title: "Sotto Servizi",
    icon: "fa fa-th-list",
    description: "Gestione dei Sotto Servizi",
  },
  {
    link: "storie",
    not: "",
    title: "Storia",
    icon: "fa fa-history",
    description: "Gestione della Storia",
  },
  {
    link: "video",
    not: "",
    title: "Video",
    icon: "fa fa-youtube",
    description: "Gestione dei Video",
  },
  {
    link: "gallerie",
    not: "",
    title: "Gallerie di Foto",
    icon: "fa fa-picture-o",
    description: "Gestione delle Gallerie di Foto",
  },
  {
    link: "formrequest",
    not: "",
    title: "Richieste",
    icon: "fa fa-envelope-o",
    description: "Richieste",
  },
];

export const APP_VERSION = "2.0";
export const EDITOR_CONFIGURATION =
  'selector:"textarea", plugins: "table",  menubar: "false", height: 400, toolbar: "table | undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent"';
